import { royalBluePalette } from '../../../themes/colors';

export const spinnerLightThemeV2 = {
  color: royalBluePalette[1000],
};
